import NotFoundState from "@rio-cloud/rio-uikit/components/states/NotFoundState"

const NotFoundStateDashboard = () => {
    return (
        <NotFoundState
            outerClassName='border-none'
            headline='Nenhuma entrada encontrada'
            message='Não foi possível encontrar nenhuma entrada de dados para sua consulta de pesquisa. Por favor, refine sua pesquisa'
        />
    )
}

export default NotFoundStateDashboard